import React, { Component, PropTypes } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { pageNavigation } from '../../actions';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import Toggle from 'material-ui/Toggle';
import { Link } from 'react-router';

const propTypes = {
  onEdit: PropTypes.string,
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
  onDisable: PropTypes.func,
  onView: PropTypes.any,
};

class ActionButtons extends Component {
  constructor() {
    super();
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  handleLinkClick(evt) {
    if (['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === -1) {
      evt.preventDefault(); // will prevent redirection
    }
  }
  render() {
    const editIcon = <FontIcon className="fa fa-pencil-square-o" />;
    const deleteIcon = <FontIcon className="fa fa-trash" />;
    const viewIcon = <FontIcon className="fa fa-eye" />;
    let disableButton = '';
    let deleteButton = '';
    let viewButton = '';
    let editButton = '';
    const isAdmin = ['0', '1'].indexOf(localStorage.getItem('scope')) !== -1;
    const disableForReadOnly = (['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === 4);

    if (this.props.onDelete) {
      deleteButton = (<li className="delete">
        <IconButton
          tooltip="Delete"
          onClick={this.props.onDelete}
          disabled={this.props.disableForOperators === true && !isAdmin}
        >
          {deleteIcon}
        </IconButton>
      </li>);
    }
    if (this.props.onView) {
      viewButton = (<li className="edit">
      <div onClick={(e)=> {
        e.preventDefault(); 
        this.props.dispatch(pageNavigation('view'))
        }}>
        <Link to={this.props.onView}>
          <IconButton tooltip="View">
            {viewIcon}
          </IconButton>
        </Link>
        </div>
      </li>);
    }
    if (this.props.onEdit) {
      editButton = (<li className="edit">
        <div onClick={(e)=> {
        e.preventDefault(); 
        this.props.dispatch(pageNavigation('edit'))
        }}>
        <Link onClick={this.handleLinkClick} to={this.props.onEdit}>
          <IconButton
            disabled={disableForReadOnly || this.props.disableForOperators === true && !isAdmin}
            tooltip="Edit"
          >
            {editIcon}
          </IconButton>
        </Link>
        </div>
      </li>);
    }
    if (this.props.onDisable) {
      disableButton = (<li className="is-disabled">
        <Toggle
          labelPosition="right"
          onToggle={this.props.onDisable}
          defaultToggled={!this.props.disabled}
          disabled={this.props.disableForOperators === true && !isAdmin}
        />
      </li>);
    }
    return (
      <div id="action-buttons">
        <ul>
          {editButton}
          {viewButton}
          {deleteButton}
          {disableButton}
        </ul>
      </div>
    );
  }
}

ActionButtons.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ActionButtons.propTypes = propTypes;

export default connect()(ActionButtons);



// WEBPACK FOOTER //
// ./src/components/home/ActionButtons.js